module.exports = __webpack_public_path__ + "static/media/contactCarousal.d01ed34f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/contactCarousal.jpg
// module id = 75
// module chunks = 0